import crypto from "crypto-js"

export const decryptCrypto = (value: string) => {
  return crypto.AES.decrypt(value, process.env.REACT_APP_AUTH_KEY).toString(
    crypto.enc.Utf8
  )
}
